import type { DokumentDetail } from "@/lib/dokumente";
import { snapshotDocFields } from "@/pages/dokumente/documentEditorSnapshot";
import {
  linkStrukturTitelLocalIds,
  toApiPosition,
  type EditorPosition,
} from "@/pages/dokumente/documentPositionModel";

export function editorPositionsToPreviewPayload(positions: EditorPosition[]) {
  const normalized = positions.map((row, idx) => ({ ...row, sort_index: idx }));
  const linked = linkStrukturTitelLocalIds(normalized);
  return linked.map((row, index) => toApiPosition(row, index, linked));
}

export function editorDocToPreviewPayload(doc: DokumentDetail) {
  return snapshotDocFields(doc);
}
